import {Subscription} from "rxjs";

export class NotificationSubscription {
  subscription!: Subscription;
  name: string;

  constructor(subscriptionName: string) {
    this.name = subscriptionName;
  }

}
